<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :sm="12" :md="8" :xl="4">
                    <el-input v-model="params.searchValue" class="input-with-select" size="small">
                        <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
                            <el-option label="用户ID" :value="1"></el-option>
                            <el-option label="手机号码" :value="2"></el-option>
                        </el-select>
                    </el-input>
                </el-col>               
                <el-col :sm="12" :md="8" :xl="4">
                    <el-select v-model="params.status" placeholder="请选择" size="small">
                        <el-option label="不限制会员状态" :value="-1"></el-option>
                        <el-option label="仅查看生效中的 " :value="1"></el-option>
                        <el-option label="仅查看已过期的" :value="2"></el-option>
						<el-option label="仅查看已取消的" :value="0"></el-option>
                    </el-select>
                </el-col>
				<el-col :sm="12" :md="8" :xl="4">
				    <el-select v-model="params.sort" placeholder="请选择" size="small">
				        <el-option label="按首次购买时间从近到远" :value="0"></el-option>
				        <el-option label="按首次购买时间从远到近" :value="1"></el-option>
				    </el-select>
				</el-col>
				<el-col :xs="24" :sm="12" :md="16" :lg="12" :xl="8">
				    <div class="clearfix timeType">
				        <el-input class="input-with-select fl" size="small">
				            <el-select v-model="params.timeType" slot="prepend" placeholder="请选择">
				                <el-option label="会员购买时间" :value="1"></el-option>
				                <el-option label="会员过期时间" :value="2"></el-option>
				            </el-select>
				        </el-input>
				        <el-date-picker v-model="datetimerange" type="datetimerange" start-placeholder="开始日期"
				            end-placeholder="结束日期" class="fl" size="small" value-format="yyyy-MM-dd HH:mm:ss"
				            :default-time="['00:00:00', '23:59:59']" align="right" unlink-panels>
				        </el-date-picker>
				    </div>
				</el-col>
                <el-col :sm="12" :md="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-btns-box">
            <el-button v-if="$utils.have('/member/export')" type="primary" icon="el-icon-download" size="small"
                @click="download" :loading="downLoading">导出列表</el-button>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
				<el-table-column prop="statusView" label="会员状态"></el-table-column>
                <el-table-column prop="userId" label="用户ID"></el-table-column>
				<el-table-column prop="userName" label="用户名"></el-table-column>				
				<el-table-column prop="userLevel" label="用户等级"></el-table-column>
				<el-table-column prop="areaCode" label="手机区号"></el-table-column>
				<el-table-column prop="tel" label="手机号"></el-table-column>
				<el-table-column prop="firstBuyTime" label="首次购买时间"></el-table-column>
				<el-table-column prop="expireTime" label="会员到期时间"></el-table-column>
				<el-table-column prop="paidAmount" label="会员付费金额"></el-table-column>
                <el-table-column fixed="right" label="操作" width="120">
                    <template slot-scope="{row} = scope">
                        <el-button
                            v-if="$utils.have('/eventManage/save')"
                            type="text"
                            size="small"
                            @click="$refs.edit.show(row.userId)"
                            >详情</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <edit ref="edit"  @onUpdate="getDataList"></edit>
    </div>
</template>
<script>
import Edit from './components/Edit.vue';
import {downloadFileTmp} from '@/assets/js/commonApi.js';
const defaultParams = {
    pageNo:1,
    searchType:1,
	searchValue:'',
	sort:0,
	status:-1,
	timeType:1,
    beginTime:'',
	endTime:''
}
export default {
    components:{
        Edit
    },
    data() {
        return {
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                searchType: parseInt(this.$route.query.searchType || 1),
                searchValue: this.$route.query.searchValue || '',
				timeType: parseInt(this.$route.query.timeType || 1),
				beginTime: this.$route.query.beginTime || '',
				endTime: this.$route.query.endTime || '',
				status:parseInt(this.$route.query.status) || -1,
				sort:parseInt(this.$route.query.sort) || 0
            },
            listLoading: true,
			downLoading: false,
			datetimerange: [this.$route.query.beginTime || '', this.$route.query.endTime || ''],
        }
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/member/list",
                method: "POST",
                data: {
                    ...this.params,
					beginTime: this.datetimerange && this.datetimerange[0] || '',
					endTime: this.datetimerange && this.datetimerange[1] || '',
                },
            })
			.then((res) => {
				const { state, msg, result } = res.data;
				if ( state == 1 && result) {
					this.data = result;
					this.dataList = result.result || [];
				} else {
                    this.data = null;
					this.dataList = [];
					this.$message.error(msg || "请求失败");
				}
			})
			.catch(() => {
				this.$message.error("请求错误");
			})
			.finally(() => {
				this.listLoading = false;
			});
        },
         //选择pageSize
         handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
			this.datetimerange = [];
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
		async download(){
			this.downLoading = true;
		    let filePath;
		    const res = await this.$request({
		        url:'/member/export',
		       data: {
		           ...this.params,
		       },
		        method: 'post',
		    })
		        .catch(err => {
		            this.$message({message: err.message, type: 'error'});
		        })
		    const{state,msg,result} = res.data;
		    if(state == 1 && result ){
		        filePath = result.url;
				this.downLoading = false
		    }else{
		        return this.$message.error(msg || '下载失败');
				this.downLoading = false
		    }   
		
		    
			await downloadFileTmp(filePath,result.fileName + '.' +this.$utils.getFileType(filePath));
		},
        //统计
        statistic(id) {
            this.$router.push({
                path: `/eventManage/list/statistic/${id}`,
                query: {
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        {
                            ...this.params,
                        }
                    ),
                },
            })
        }
    }
}
</script>
<style lang="scss" scoped>

</style>